import { H4, Icon } from '@blueprintjs/core';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import styled from 'styled-components';

import useEditorItemContext from '../../context/editorItemContext';
import useEditorContext from '../../context/editorContext';

import OPTIONS from '.';
import PageCard from '../components/pageCard';
import DialogPanelBody from '../components/dialogPanelBody';

const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-left: -8px;
  margin-right: -8px;
`;

const GridItem = styled.div`
  flex: 0 0 ${100 / 3}%;
  max-width: ${100 / 3}%;
  padding-left: 8px;
  padding-right: 8px;
  margin-bottom: 16px;
`;

// TODO 264 Why isn't the top margin merged with modal body margin?
// - Then the first-child hack wouldn't be needed.
const StyledH4 = styled(H4)`
  margin-top: 30px;
  margin-bottom: 20px;

  &:first-child {
    margin-top: 10px;
  }
`;

const StyledIcon = styled(Icon)`
  margin-right: 5px;
  vertical-align: top;
`;

const renderSectionIcon = id => {
  switch (id) {
    case 'page':
      return (
        <StyledH4>
          <StyledIcon icon="document" iconSize={20} /> Add pages
        </StyledH4>
      );
    case 'person':
      return (
        <StyledH4>
          <StyledIcon icon="person" iconSize={20} /> Add people
        </StyledH4>
      );
    default:
      return null;
  }
};

// TODO 264 ! Disable people, that already have the page added.
// - Disabled card style is prepared at PersonCard.disable
const ContentWizardPanel = ({ closeDialog, openPanel, ...params }) => {
  const editorContext = useEditorContext();
  const editorItemContext = useEditorItemContext();
  const { item, config, template } = editorItemContext;

  const addPages = (pages, { index = -1, sortByTags = false } = {}) => {
    // TODO some param is required - sortByTags only for records and photos.
    editorContext.addPages(item.id, pages, { index, sortByTags });
    closeDialog();

    if (index === -1 && !sortByTags) {
      params.onNewPage(item.pages.length);
    }
  };

  const handleClick = card => {
    card.onSelect({ addPages, card, openPanel, template });
  };

  const contentOptions = useMemo(() => {
    if (!config.contentOptions) {
      return null;
    }

    let value = config.contentOptions;
    if (Array.isArray(config.contentOptions)) {
      value = { default: config.contentOptions };
    }

    return Object.entries(value).reduce((acc, [key, options]) => {
      const validOptions = options.map(id => ({ id, ...OPTIONS[id] })).filter(option => !!option);
      if (validOptions.length > 0) {
        acc.push({
          key,
          header: renderSectionIcon(key),
          options: validOptions,
        });
      }
      return acc;
    }, []);
  }, [config.contentOptions]);

  return (
    <DialogPanelBody>
      {contentOptions.map(category => (
        <React.Fragment key={category.key}>
          {category.header}
          <Grid>
            {category.options.map(option => (
              <GridItem key={option.id}>
                <PageCard
                  className="h-100"
                  onClick={() => handleClick(option)}
                  text={option.text}
                  title={option.title}
                  disabled={option.isDisabled(editorItemContext)}
                />
              </GridItem>
            ))}
          </Grid>
        </React.Fragment>
      ))}
    </DialogPanelBody>
  );
};

ContentWizardPanel.propTypes = {
  closeDialog: PropTypes.func.isRequired,
  openPanel: PropTypes.func.isRequired,
};

export default ContentWizardPanel;
